import React, { useState } from "react";
import {
  EuiForm,
  EuiFormRow,
  EuiFieldText,
  EuiButton,
  EuiText,
  EuiFieldPassword,
} from "@elastic/eui";
import "../../assets/styles/login.css";
import LoginService from "../../services/login-service";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const LoginComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [isUsernameInvalid, setIsUsernameInvalid] = useState(false);
  const [usernameInvalidText, setUserameInvalidText] = useState();

  const [isPasswordInvalid, setIsPasswordInvalid] = useState(false);

  const [invalidLogin, setInvalidLogin] = useState(false);
  const [invalidLoginText, setInvalidLoginText] = useState();

  const [username, setUserame] = useState();
  const [password, setPassword] = useState();

  let navigate = useNavigate();

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const userNameChanged = (e) => {
    setIsUsernameInvalid(false);
    setInvalidLogin(false);
    setUserame(e.target.value);
  };
  const passwordChanged = (e) => {
    setIsUsernameInvalid(false);

    setPassword(e.target.value);
  };

  const loginSubmitted = () => {
    if (!username) {
      setIsUsernameInvalid(true);
      setUserameInvalidText("Username is required");
      return;
    }
    if (!password) {
      setIsPasswordInvalid(true);
      return;
    }

    const isValid = validateEmail(username);

    if (!isValid) {
      setIsUsernameInvalid(true);
      setUserameInvalidText("Invalid format: jhon.doe@astroline.com");
      return;
    }
    setIsLoading(true);
    setIsDisabled(true);

    LoginService.login(username, password)
      .then(async (response) => {
        if (response.status !== 200) {
          setInvalidLogin(true);
          setInvalidLoginText("Wrong username/password");
          return;
        } else if (
          response.status === 200 &&
          response.data.status === "Success"
        ) {
          setIsLoading(false);
          setIsDisabled(false);
          sessionStorage.setItem("krakenC", "dem");
          sessionStorage.setItem("krakenT", response.data.accessToken);
          localStorage.setItem("CL", response.data.companyLogo);
          localStorage.setItem("UN", response.data.name);
          localStorage.setItem("CN", response.data.companyName);
          sessionStorage.setItem("pToken", response.data.pToken);

          const token = response.data.pToken;
          console.log(token);
          axios
            .get(
              `https://graph.microsoft.com/v1.0/users/${username}/photo/$value`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
              }
            )
            .then((o) => {
              const url = window.URL || window.webkitURL;
              const blobUrl = url.createObjectURL(o.data);
              sessionStorage.setItem("photoUser", blobUrl);
              console.log(blobUrl);
            })
            .catch((e) => {
              console.log(e);
            });
          navigate(`/`);
        } else {
          setInvalidLogin(true);
          setInvalidLoginText("Wrong username/password");
        }
      })
      .catch((error) => {
        setInvalidLogin(true);
        setInvalidLoginText("Wrong username/password");
        setIsLoading(false);
        setIsDisabled(false);
      });
  };
  return (
    <div className="body">
      <div
        style={{
          position: "absolute",
          marginLeft: "50%",
          height: 200,
          marginTop: "8%",
        }}
      >
        <EuiText
          style={{
            fontSize: "50px",
            fontFamily: "Segoe UI",
          }}
          color={"white"}
        >
          {" "}
          <b>DEM - Internal management</b>
        </EuiText>
      </div>
      <div
        style={{
          position: "absolute",
          marginLeft: "65%",
          height: 200,
          marginTop: "20%",
        }}
      >
        <EuiForm component="form">
          <EuiFormRow label="Username">
            <EuiFieldText
              style={{ width: 500 }}
              name="first"
              isInvalid={isUsernameInvalid}
              onChange={(e) => userNameChanged(e)}
            />
          </EuiFormRow>
          {isUsernameInvalid && (
            <EuiText size="xs" color={"danger"}>
              {usernameInvalidText}
            </EuiText>
          )}
          <EuiFormRow label="Password">
            <EuiFieldPassword
              type="dual"
              isInvalid={isPasswordInvalid}
              onChange={(e) => passwordChanged(e)}
              aria-label="Use aria labels when no actual label is in use"
            />
          </EuiFormRow>
          {isPasswordInvalid && (
            <EuiText size="xs" color={"danger"}>
              Password is required
            </EuiText>
          )}
          <EuiFormRow hasEmptyLabelSpace>
            <EuiButton
              isLoading={isLoading}
              isDisabled={isDisabled}
              onClick={loginSubmitted}
            >
              Login
            </EuiButton>
          </EuiFormRow>
          {invalidLogin && (
            <EuiText size="s" color={"danger"}>
              {invalidLoginText}
            </EuiText>
          )}
        </EuiForm>
      </div>
    </div>
  );
};

export default LoginComponent;
